// HEAVY module — imports raw recharts. Only reachable via `charts/lazy.tsx`.
import * as React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { type ChartPalette, useChartPalette } from "./chart-theme";
import type { ModelMixChartProps, ModelMixSlice } from "./chart-types";

interface MixTooltipPayloadEntry {
  payload?: ModelMixSlice;
}

interface MixTooltipProps {
  active?: boolean;
  payload?: MixTooltipPayloadEntry[];
  formatValue: (value: number) => string;
}

function MixTooltip({ active, payload, formatValue }: MixTooltipProps): React.ReactElement | null {
  const slice: ModelMixSlice | undefined = active ? payload?.[0]?.payload : undefined;
  if (!slice) return null;
  return (
    <div className="aichat-analytics__chart-tooltip">
      <div className="aichat-analytics__chart-tooltip-title">{slice.name}</div>
      <div className="aichat-analytics__chart-tooltip-row">{formatValue(slice.value)} credits</div>
    </div>
  );
}

function ModelMixChart({ slices, size = 180, formatValue }: ModelMixChartProps): React.ReactElement {
  const palette: ChartPalette = useChartPalette();

  return (
    <div style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={slices}
            dataKey="value"
            nameKey="name"
            innerRadius="62%"
            outerRadius="95%"
            paddingAngle={2}
            stroke="none"
            isAnimationActive={false}
          >
            {slices.map((slice: ModelMixSlice, index: number) => (
              <Cell key={slice.name} fill={palette.series[index % palette.series.length]} />
            ))}
          </Pie>
          <Tooltip content={<MixTooltip formatValue={formatValue} />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ModelMixChart;
